import { ThumborImageLib } from '@gynzy/lib-js-thumbor';
import ThumborFit from '@/enums/thumbor-fit';

class ThumborImageService {
	static instance = null;

	static thumborLib = null;

	static getInstance() {
		if (ThumborImageService.instance == null) {
			ThumborImageService.instance = new ThumborImageService();
		}

		this.instance.thumborLib = new ThumborImageLib(process.env.THUMBOR_URL, process.env.MEDIA_BUCKET);
		return this.instance;
	}

	getThumborUrlForImage(imgPath, width, height, settings = {}) {
		const defaultSettings = { useCachingGroups: false, fit: ThumborFit.NONE };

		return this.thumborLib.getThumborUrlForImage(imgPath, width, height, {
			...defaultSettings,
			...settings,
		});
	}
}

export default ThumborImageService;
